var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div'),_c('div',{staticClass:"vs-con-loading__container",attrs:{"id":"preview-loading"}},[(_vm.currentTabIndex === 0)?_c('Decentralize'):(_vm.currentTabIndex === 1)?_c('LocalDisk',{attrs:{"url":_vm.url}}):(_vm.currentTabIndex === 2)?_c('PublicCloud'):_c('PrivateCloud')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }